__turbopack_context__.v({
  "avatar": "QvTHHq_avatar",
  "incomplete": "QvTHHq_incomplete",
  "large": "QvTHHq_large",
  "medium": "QvTHHq_medium",
  "shimmer": "QvTHHq_shimmer",
  "small": "QvTHHq_small",
  "text-bar-sweep": "QvTHHq_text-bar-sweep",
});
